import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService, UserService } from '../../services';

@Injectable()

export class RouteGuardComponent {
  constructor(private authService: AuthService, private _userService: UserService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    /*
    const currentUser = this.authService.getCurrentlyLoggedInUser();
    const userRoute = this._userService.getRouteForUser(currentUser.userType);
    console.log('Current User: ', currentUser);
    console.log('User Route: ', userRoute);
    */

    const currentUser = this.authService.getCurrentlyLoggedInUser();

    if (!currentUser) {
      // Set the url incase someone entered link and was not logged in. This will allow us to redirect them back after login.
      if (!['/', '/login'].includes(window.location.pathname)) this.authService.redirectUrl = window.location.pathname;
      // console.log('Path trying to access: ', window.location.pathname);

      this.router.navigate(['/login']);
      return false;
    }

    if (!this.authService.isTokenExpired()) {
      // console.log('Token is not expired.')

      let result = true;

      const anypermissions = route.data['anypermissions'] as Array<string>;
      // console.log('anypermissions: ', anypermissions);

      if (result && anypermissions) {
        let anyResult = false;

        for (let i = 0; i < anypermissions.length; i++) {
          if (this.authService.doesUserHaveAccessForGivenType(anypermissions[i])) {
            anyResult = true;
          }
        }

        result = result && anyResult;
        // console.log('Result: ', result);
      }

      if (result) {
        return true;
      }
    }

    this.router.navigate(['/login']);
    return false;
  }
}